import React, { Component } from "react";
import {
    Typography,
    Snackbar,
    SnackbarContent,
    IconButton,
    Button,
    List,
    Grid,
    ListItem,
} from "@material-ui/core";
import { Print as PrintIcon } from "@material-ui/icons";
import _ from "lodash";
import styled from "styled-components";
import { connect } from "react-redux";
import { List as ListIcon, LocationOn as MapIcon } from "@material-ui/icons";
import {
    getReportTitles,
    getUserData,
    setFilterReportType,
    setDepartment,
    setArea,
    setFilterUserUid,
    setSearchDateFrom,
    setDay,
    setSearchDateTo,
    setReportFilterState,
    setPage,
    setRowsPerPage,
    setReportStatus,
    setSelectedRow,
    setReportEditStatus,
    setStatusChangeModal,
    deleteReport,
    setDeleteStatus,
    setJobID,
    setYear,
    setMonth,
    redirectTo,
    getTotalJobPacks,
    setReport,
    particularReportsdata,
    setClientName
} from "./actions";
import MapContainer from "./MapContainer";
import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";

import {
    selectReportTitles,
    selectUserNames,
    selectFilterReportType,
    selectFilterUserUid,
    selectSearchDateFrom,
    selectSearchDateTo,
    selectReportFilterState,
    selectPage,
    paginatedReportList,
    selectRowsPerPage,
    selectSelectedRow,
    selectChangeReportStatusModal,
    selectDeleteStatus,
    selectReportFilterJobID,
    selectReportYear,
    selectReportMonth,
    getRequesting,
    canUpdate,
    canCreate,
    canDelete,
    selectedArea,
    selectedDepartment,
    selectAreas,
    selectDepartments,
    selectJobPackIDs,
    selectParticularReports,
    selectNonInvoicedReports,
    selectPermissions,
    selectDay,
    selectClientName,
    clientDetails
} from "./selectors";
import "./submittedReportsStyles.css";
import Filters from "./Filters";
import TableData from "./TableData";
import ChangeStatusModal from "./ChangeStatusModal";
import {
    Modal,
    ModalBody,
    Spinner,
    ModalFooter,
    ModalHeader,
    Row,
} from "reactstrap";
import ReactToPrint from "react-to-print";
const StyledListItem = styled(ListItem)`
    background: white;
    border: 1px solid #ddd;
    border-radius: 0px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin-top: 24px;
    border-left: 4px solid ${(props) => props.borderColor};
    :first & {
        margin-top: 0px;
    }
`;

class SubmittedReportsV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageView: "list",
            invoicedReports: false,
        };
        props.getReportTitles();
        props.getUserData();
        props.getTotalJobPacks();
    }
    handleCloseGroupModal = () => {
        this.setState({ invoicedReports: false });
    };
    render() {
        const {
            reportTitles,
            users,
            selectedReportType,
            selectedUser,
            dateFrom,
            dateTo,
            day,
            setFilterReportType,
            setDepartment,
            setArea,
            setFilterUserUid,
            setSearchDateFrom,
            setSearchDateTo,
            filterState,
            setReportFilterState,
            tableData,
            page,
            rowsPerPage,
            setPage,
            setRowsPerPage,
            selectedRow,
            setSelectedRow,
            setReportStatus,
            setReportEditStatus,
            changeStatusModalInfo,
            setStatusChangeModal,
            deletedStatus,
            deleteReport,
            jobID,
            setJobID,
            setYear,
            setMonth,
            canUpdate,
            canDelete,
            departments,
            areas,
            particularReports,
            year,
            area,
            department,
            month,
            nonInvoicedReports,
            setDay,
            setClientName,
            clientName
        } = this.props;
        const { pageView } = this.state;
        const jobIDs =
            this.props.jobPackIDs === false ? [] : this.props.jobPackIDs;
        return (
            <>
                <StyledCard>
                    <div>
                        <StyledHeader>
                            <Typography variant="h5">
                                Submitted Reports
                                <div
                                    style={{
                                        float: "right",
                                        marginTop: "-8px",
                                    }}
                                >
                                    <Button
                                        style={{
                                            width: "270px",
                                            marginLeft: "30px",
                                            background: "#0188cc",
                                        }}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            this.setState({
                                                invoicedReports: true,
                                            });
                                            // this.props.printExpiry();
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                color: "white",
                                                fontSize: "13px",
                                            }}
                                        >
                                            Print All Non Invoiced Reports
                                        </Typography>
                                    </Button>
                                    <IconButton
                                        value="map"
                                        variant="contained"
                                        color="default"
                                        style={{
                                            color:
                                                this.state.pageView === "map"
                                                    ? "#0188cc"
                                                    : "",
                                            border:
                                                this.state.pageView === "map"
                                                    ? "1px solid #0188cc"
                                                    : "0px",
                                        }}
                                        onClick={(e) => {
                                            this.setState({
                                                pageView: "map",
                                            });
                                        }}
                                    >
                                        {" "}
                                        <MapIcon />
                                    </IconButton>
                                    <IconButton
                                        value="list"
                                        variant="contained"
                                        color={
                                            this.state.pageView === "list"
                                                ? "primary"
                                                : "default"
                                        }
                                        style={{
                                            color:
                                                this.state.pageView === "list"
                                                    ? "#0188cc"
                                                    : "",
                                            border:
                                                this.state.pageView === "list"
                                                    ? "1px solid #0188cc"
                                                    : "0px",
                                        }}
                                        onClick={(e) => {
                                            this.setState({
                                                pageView: "list",
                                            });
                                        }}
                                    >
                                        <ListIcon />
                                    </IconButton>
                                </div>
                            </Typography>
                        </StyledHeader>
                        <StyledContent>
                            <Modal
                                isOpen={this.props.requesting}
                                style={{ maxWidth: "00px" }}
                            >
                                <ModalBody>
                                    {this.props.requesting && (
                                        <div
                                            style={{
                                                textAlign: "center",
                                                paddingTop: "3em",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    background: "white",
                                                    width: "fit-content",
                                                    display: "inline-block",
                                                    padding: "2em",
                                                }}
                                            >
                                                <Spinner
                                                    style={{
                                                        height: 100,
                                                        width: 100,
                                                        background: "white",
                                                    }}
                                                    color="primary"
                                                />
                                                <Typography
                                                    style={{
                                                        textAlign: "center",
                                                        marginTop: 15,
                                                        color:
                                                            "rgba(0, 0, 0, 0.87)",
                                                        fontWeight: "bolder",
                                                        fontSize: 20,
                                                    }}
                                                    variant="body2"
                                                >
                                                    Processing...
                                                </Typography>
                                            </div>
                                        </div>
                                    )}
                                </ModalBody>
                            </Modal>

                            <Filters
                                reportTitles={reportTitles}
                                users={users}
                                viewType={this.state.pageView}
                                reportType={selectedReportType}
                                user={selectedUser}
                                dateFrom={dateFrom}
                                dateTo={dateTo}
                                setReportType={setFilterReportType}
                                setUser={setFilterUserUid}
                                setDateFrom={setSearchDateFrom}
                                setDateTo={setSearchDateTo}
                                setDayFrom={setDay}
                                setClientName={setClientName}
                                day={day}
                                jobID={jobID}
                                setJobID={setJobID}
                                year={year}
                                setYear={setYear}
                                month={month}
                                setMonth={setMonth}
                                setView={(view) => {
                                    this.setState({ pageView: view });
                                }}
                                setArea={setArea}
                                setDepartment={setDepartment}
                                areas={areas}
                                departments={departments}
                                area={area}
                                department={department}
                                clientName={clientName}
                                clientDetails={this.props.clientDetails}
                            />
                            {pageView === "list" && (
                                <TableData
                                    filterState={filterState}
                                    setFilterState={setReportFilterState}
                                    tableData={tableData}
                                    users={users}
                                    page={page}
                                    setReportStatus={setReportStatus}
                                    rowsPerPage={rowsPerPage}
                                    setPage={setPage}
                                    setRowsPerPage={setRowsPerPage}
                                    reportTitles={reportTitles}
                                    setStatus={setReportStatus}
                                    selectedRow={selectedRow}
                                    setSelectedRow={setSelectedRow}
                                    setEditStatus={setReportEditStatus}
                                    setModalInfo={setStatusChangeModal}
                                    canUpdate={canUpdate}
                                    canDelete={canDelete}
                                    jobIDs={jobIDs}
                                    particularReports={particularReports}
                                    year1={year}
                                    permissions={this.props.permissions}
                                    month1={month}
                                />
                            )}
                            {pageView === "map" && (
                                <StyledViewContainer
                                    style={{ paddingTop: "0px" }}
                                >
                                    <MapContainer
                                        users={users}
                                        reports={tableData}
                                        report_titles={reportTitles}
                                        redirectTo={this.props.redirectTo}
                                    />
                                </StyledViewContainer>
                            )}
                        </StyledContent>
                    </div>
                </StyledCard>{" "}
                <ChangeStatusModal
                    reportTitles={reportTitles}
                    users={users}
                    setEditStatus={setReportEditStatus}
                    setReportStatus={setReportStatus}
                    modalInfo={changeStatusModalInfo}
                    setModalInfo={setStatusChangeModal}
                    deleteReport={deleteReport}
                    year={year}
                    month={month}
                />
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    autoHideDuration={4000}
                    open={
                        deletedStatus.deleteSuccess || deletedStatus.deleteFail
                    }
                    onClose={() => {
                        this.props.setDeleteStatus();
                    }}
                >
                    <SnackbarContent
                        style={{
                            backgroundColor: deletedStatus.deleteSuccess
                                ? "green"
                                : deletedStatus.deleteFail
                                ? "red"
                                : "white",
                            color: "white",
                        }}
                        message={
                            deletedStatus.deleteSuccess
                                ? "Report Successfully Deleted"
                                : "Unable to Delete Report, Please Contact System Admin With Report Details"
                        }
                    />
                </Snackbar>
                <Modal
                    isOpen={this.state.invoicedReports}
                    style={{ width: "1000px" }}
                >
                    <ModalHeader>Print All Non invoiced Reports</ModalHeader>

                    <ModalBody>
                        <Row>
                            &nbsp;Total &nbsp;
                            <b>
                                {nonInvoicedReports &&
                                    nonInvoicedReports.length}{" "}
                            </b>
                            &nbsp;Non invoiced Reports &nbsp;
                            <ReactToPrint
                                style={{ float: "right" }}
                                trigger={() => (
                                    <Button
                                        variant="contained"
                                        size="small"
                                        color="primary"
                                        style={{
                                            marginLeft: "85px",
                                            color: "white",
                                            background: "#0188cc",
                                        }}
                                    >
                                        <PrintIcon /> Print
                                    </Button>
                                )}
                                content={() => this.componentRef1}
                            />
                            &nbsp;&nbsp;
                            <div>
                                <Button
                                    style={{
                                        background: "#EF5350",
                                        color: "white",
                                    }}
                                    onClick={this.handleCloseGroupModal}
                                >
                                    Close
                                </Button>
                            </div>
                        </Row>
                        <br />
                        <div ref={(el) => (this.componentRef1 = el)}>
                            <Row>
                                <List
                                    style={{
                                        background: "#eee",
                                        width: "100%",
                                    }}
                                >
                                    <div
                                        style={{
                                            clear: "both",
                                            border: "2px solid #0188cc",
                                            borderRadius: "6px",
                                            marginLeft: "5px",
                                            marginTop: "10px",
                                        }}
                                    >
                                        <h1
                                            style={{
                                                backgroundColor: "#0188cc",
                                                textAlign: "center",
                                                padding: "4px",
                                                fontWeight: "bold",
                                                color: "white",
                                                fontSize: "22px",
                                            }}
                                        >
                                            Non Invoiced Reports
                                        </h1>
                                    </div>
                                    {nonInvoicedReports &&
                                        nonInvoicedReports.map((e, index) => {
                                            let user = _.find(users, {
                                                uid: e.uid,
                                            });
                                            return (
                                                <StyledListItem
                                                    borderColor={"#0188cc"}
                                                    style={{
                                                        root: {
                                                            borderLeft:
                                                                "#0188cc",
                                                        },
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Grid container spacing={6}>
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={12}
                                                            lg={6}
                                                            xl={6}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                style={{
                                                                    paddingLeft: 24,
                                                                }}
                                                            >
                                                                <b>
                                                                    Report Type:{" "}
                                                                </b>
                                                                {e.report_type.replace(
                                                                    /_/g,
                                                                    " "
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                        <br />
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={12}
                                                            lg={6}
                                                            xl={6}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                style={{
                                                                    paddingLeft: 24,
                                                                }}
                                                            >
                                                                <b>
                                                                    User Name:{" "}
                                                                </b>
                                                                {user
                                                                    ? user.user_name
                                                                    : "N/A"}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={12}
                                                            lg={6}
                                                            xl={6}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                style={{
                                                                    paddingLeft: 24,
                                                                }}
                                                            >
                                                                <b>
                                                                    Timestamp:{" "}
                                                                </b>
                                                                {e.timestamp}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            sm={12}
                                                            md={12}
                                                            lg={6}
                                                            xl={6}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                style={{
                                                                    paddingLeft: 24,
                                                                }}
                                                            >
                                                                <b>
                                                                    Jobpack Id:{" "}
                                                                </b>
                                                                {e.subject_name ===
                                                                "reports"
                                                                    ? "N/A"
                                                                    : e.subject_child}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </StyledListItem>
                                            );
                                        })}
                                </List>
                            </Row>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            <Button onClick={this.handleCloseGroupModal}>
                                Close
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
export default connect(
    (store) => {
        return {
            reportTitles: selectReportTitles(store),
            users: selectUserNames(store),
            selectedReportType: selectFilterReportType(store),
            selectedUser: selectFilterUserUid(store),
            dateFrom: selectSearchDateFrom(store),
            dateTo: selectSearchDateTo(store),
            filterState: selectReportFilterState(store),
            tableData: paginatedReportList(store),
            page: selectPage(store),
            rowsPerPage: selectRowsPerPage(store),
            selectedRow: selectSelectedRow(store),
            changeStatusModalInfo: selectChangeReportStatusModal(store),
            deletedStatus: selectDeleteStatus(store),
            jobID: selectReportFilterJobID(store),
            year: selectReportYear(store),
            month: selectReportMonth(store),
            requesting: getRequesting(store),
            canUpdate: canUpdate(store),
            canCreate: canCreate(store),
            canDelete: canDelete(store),
            departments: selectDepartments(store),
            areas: selectAreas(store),
            jobPackIDs: selectJobPackIDs(store),
            area: selectedArea(store),
            department: selectedDepartment(store),
            particularReports: selectParticularReports(store),
            nonInvoicedReports: selectNonInvoicedReports(store),
            permissions: selectPermissions(store),
            day: selectDay(store),
            clientName: selectClientName(store),
            clientDetails: clientDetails(store)
        };
    },
    {
        getReportTitles,
        getUserData,
        setFilterReportType,
        setFilterUserUid,
        setSearchDateFrom,
        setDay,
        setSearchDateTo,
        setReportFilterState,
        setPage,
        setRowsPerPage,
        setReportStatus,
        setSelectedRow,
        setReportEditStatus,
        setStatusChangeModal,
        deleteReport,
        setDeleteStatus,
        setJobID,
        setYear,
        setMonth,
        setDepartment,
        setArea,

        redirectTo,
        getTotalJobPacks,
        setReport,
        particularReportsdata,
        setClientName
    }
)(SubmittedReportsV2);
